const getRootAPIUri = () => (window.location.hostname.includes('localhost')
  ? 'http://a.m.localhost:3000/api'
  : '/api');

export default getRootAPIUri;
